import React, { useEffect, useState } from "react";
import { virtualMallSingleIdWelcomeCertificatesApi } from "./VirtualMallApi/api.js";

export default function VirtualMallWelcomeCertificate() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    virtualMallSingleIdWelcomeCertificatesApi()
      .then((response) => {
        if (!active) return;
        if (!response?.status) throw new Error(response?.message || "Could not load certificates");
        setCertificates(Array.isArray(response.data) ? response.data : []);
      })
      .catch((requestError) => {
        if (active) setError(requestError.message || "Could not load your certificates.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  return (
    <section style={{ background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 4px 18px rgba(31, 45, 61, .08)" }}>
      <h2 style={{ textAlign: "center", color: "#202c43", margin: "4px 0 10px" }}>Welcome Certificate</h2>
      <p style={{ textAlign: "center", color: "#69758a", margin: "0 0 24px" }}>
        Your newly created Single ID and its sign-in password are shown here.
      </p>

      {loading && <p style={{ textAlign: "center", color: "#69758a" }}>Loading your certificate…</p>}
      {!loading && error && <p role="alert" style={{ textAlign: "center", color: "#c0392b" }}>{error}</p>}
      {!loading && !error && certificates.length === 0 && (
        <p style={{ textAlign: "center", color: "#69758a", padding: 24 }}>
          No new Single ID certificates are available yet. Certificates appear here after an order is approved.
        </p>
      )}

      {!loading && !error && certificates.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(270px, 420px))", justifyContent: "center", gap: 20 }}>
          {certificates.map((certificate) => (
            <article key={certificate.order_id} style={{ border: "1px solid #dce4f0", borderTop: "4px solid #21a366", borderRadius: 14, padding: 22, boxShadow: "0 8px 22px rgba(31, 45, 61, .08)" }}>
              <div style={{ textAlign: "center", fontSize: 32, marginBottom: 4 }} aria-hidden="true">🎉</div>
              <h3 style={{ textAlign: "center", color: "#202c43", margin: "0 0 18px" }}>Welcome to Springway</h3>
              <div style={{ display: "grid", gap: 12, color: "#536176" }}>
                <div><strong>Product:</strong> {certificate.product_name}</div>
                <div><strong>Name:</strong> {certificate.name}</div>
                <div><strong>Single ID:</strong> <span style={{ color: "#4f63d9", fontWeight: 700 }}>{certificate.single_id}</span></div>
                <div><strong>Mobile:</strong> {certificate.mobile}</div>
                <div style={{ background: "#f1f5fb", borderRadius: 8, padding: 12, overflowWrap: "anywhere" }}>
                  <strong>Password:</strong> <code>{certificate.password}</code>
                </div>
              </div>
              <p style={{ color: "#7b8798", fontSize: 13, margin: "16px 0 0" }}>
                Order #{certificate.order_id} · {certificate.certificate_created_at ? new Date(certificate.certificate_created_at).toLocaleDateString() : ""}
              </p>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
